
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"12","viewBox":"0 0 10 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.4 11.145V.645h.21c.17 0 .67-.005 1.5-.015C2.94.61 3.475.6 3.715.6c1.98 0 3.455.49 4.425 1.47.98.98 1.47 2.225 1.47 3.735 0 1.55-.525 2.835-1.575 3.855-1.04 1.01-2.52 1.515-4.44 1.515-.15 0-.585-.005-1.305-.015-.72-.01-1.265-.015-1.635-.015H.4zM3.685 2.85c-.39 0-.685.015-.885.045v6c.21.02.5.03.87.03 1.05 0 1.875-.27 2.475-.81.61-.55.915-1.32.915-2.31 0-.94-.31-1.665-.93-2.175-.62-.52-1.435-.78-2.445-.78z","fill":"#fff"}})])
          )
        }
      }
    